/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfAccountantPouchOperationListedAdminDto } from '../models/Pagination1OfAccountantPouchOperationListedAdminDto';
import type { Pagination1OfDriverPouchOperationListedAdminDto } from '../models/Pagination1OfDriverPouchOperationListedAdminDto';
import type { Pagination1OfDriverRoundDifferencePouchOperationListedAdminDto } from '../models/Pagination1OfDriverRoundDifferencePouchOperationListedAdminDto';
import type { PouchOperationActivityType } from '../models/PouchOperationActivityType';
import type { PouchType } from '../models/PouchType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PouchOperationsService {
    /**
     * **Required Policy:** `ViewDriverPouchOperations`
     * @returns Pagination1OfDriverPouchOperationListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverPouchOperationsAdmin({
        pouchId,
        userId,
        fromPouchDriverId,
        fromDate,
        toDate,
        type,
        counterpartyPouchType,
        counterpartyUserId,
        hasRoundDifference,
        referenceCode,
        page,
        limit,
    }: {
        pouchId: number,
        userId?: string,
        fromPouchDriverId?: number,
        fromDate?: string,
        toDate?: string,
        type?: PouchOperationActivityType,
        counterpartyPouchType?: PouchType,
        counterpartyUserId?: string,
        hasRoundDifference?: boolean,
        referenceCode?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverPouchOperationListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouchoperations/drivers',
            query: {
                'pouchId': pouchId,
                'userId': userId,
                'fromPouchDriverId': fromPouchDriverId,
                'fromDate': fromDate,
                'toDate': toDate,
                'type': type,
                'counterpartyPouchType': counterpartyPouchType,
                'counterpartyUserId': counterpartyUserId,
                'hasRoundDifference': hasRoundDifference,
                'referenceCode': referenceCode,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewAccountantPouchOperations`
     * @returns Pagination1OfAccountantPouchOperationListedAdminDto OK
     * @throws ApiError
     */
    public static getAccountantPouchOperationsAdmin({
        pouchId,
        userId,
        fromPouchDriverId,
        fromDate,
        toDate,
        type,
        counterpartyPouchType,
        counterpartyUserId,
        hasRoundDifference,
        referenceCode,
        page,
        limit,
    }: {
        pouchId: number,
        userId?: string,
        fromPouchDriverId?: number,
        fromDate?: string,
        toDate?: string,
        type?: PouchOperationActivityType,
        counterpartyPouchType?: PouchType,
        counterpartyUserId?: string,
        hasRoundDifference?: boolean,
        referenceCode?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfAccountantPouchOperationListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouchoperations/accountants',
            query: {
                'pouchId': pouchId,
                'userId': userId,
                'fromPouchDriverId': fromPouchDriverId,
                'fromDate': fromDate,
                'toDate': toDate,
                'type': type,
                'counterpartyPouchType': counterpartyPouchType,
                'counterpartyUserId': counterpartyUserId,
                'hasRoundDifference': hasRoundDifference,
                'referenceCode': referenceCode,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverPouchOperations`
     * @returns Pagination1OfDriverRoundDifferencePouchOperationListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverRoundDifferencePouchOperationsAdmin({
        fromPouchId,
        toPouchId,
        fromDate,
        toDate,
        regionId,
        page,
        limit,
    }: {
        fromPouchId?: number,
        toPouchId?: number,
        fromDate?: string,
        toDate?: string,
        regionId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverRoundDifferencePouchOperationListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/pouchoperations/drivers/round-difference',
            query: {
                'fromPouchId': fromPouchId,
                'toPouchId': toPouchId,
                'fromDate': fromDate,
                'toDate': toDate,
                'regionId': regionId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `WithdrawalAccountantPouch`
     * @returns any OK
     * @throws ApiError
     */
    public static postPouchOperationAdmin({
        pouchId,
        amount,
        description,
        dateTime,
    }: {
        pouchId: number,
        amount: number,
        description?: string,
        dateTime?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/pouchoperations',
            query: {
                'pouchId': pouchId,
                'amount': amount,
                'description': description,
                'dateTime': dateTime,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `WithdrawalDriverPouch`
     * @returns any OK
     * @throws ApiError
     */
    public static postPouchOperationSelfTransferAdmin({
        pouchId,
        amount,
        description,
        dateTime,
    }: {
        pouchId: number,
        amount: number,
        description?: string,
        dateTime?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/pouchoperations/self-transfer',
            query: {
                'pouchId': pouchId,
                'amount': amount,
                'description': description,
                'dateTime': dateTime,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
